import { Text } from "@chakra-ui/react"

export const TextGradient = ({ children, fromColor, toColor, ...textProps }) => {
	return (
		<Text 
			bgGradient={`linear(to-r, ${fromColor}, ${toColor})`} 
			bgClip='text'
			{...textProps}
		>
			{children}
		</Text>
	)
}